var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKirazlidere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.7,32.3c-2.7-.9-5.3-1.6-7.8-2.5-1.3-.4-1-1.6-.7-2.5,1-3.6,2.1-7.2,3-10.9.3-1,.6-2.1.7-3.2.2-5.2,3.7-7.8,7.6-10.2,1.1-.7,1.8-.2,2.6.5,3.3,2.7,6.3,5.7,9,9,1.4,1.7,2.7,2.4,4.9,1.4,1.3-.6,2.8-.9,4.3-1.3.9-.2,2-1.1,2.5.4.3,1,.4,2.4-.8,2.9-3.7,1.9-5.3,5.2-6.7,8.7-.3.7-.5,1.4-1.3,1.4-4.2-.4-7.3,2.3-10.8,3.7-2.2.9-4.4,1.8-6.5,2.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKirazlidere);
export default __webpack_public_path__ + "static/media/kirazlidere.22e04dc220abae6f948744b5798af9e8.svg";
export { ForwardRef as ReactComponent };